import './bause/style';
import FormStructure from './bause/form_structure';

export default FormStructure;